import { HttpStatusCode } from "axios";
import keyCloakApiService from "../../apiServices/common/keyCloakApiService";
import { setUserDetails } from "../../store/slices/user/userSlice";

export function loginUser(username:string, password:string , callback: Function, setLoader:Function) {
    return async function (dispatch: any, getState: any) {
      let response = await keyCloakApiService.loginUser(username, password);
      if (response.status == HttpStatusCode.Ok && response.data.access_token !== null) {
        dispatch(setUserDetails(response.data));
        localStorage.setItem("token", response?.data?.access_token as string);
        localStorage.setItem("refresh_token", response?.data?.refresh_token as string);
        callback && callback();
      }
      else{
        alert("login failed");
        setLoader(false);
      }
    };
  }

  export function getCollegeAdmins() {
    return async function (dispatch: any, getState: any) {
      let response = await keyCloakApiService.getUsersBasedOnRole("Super%Admin");
      if (response) {
        console.log(response);
      }
    };
  }

  export function logoutUser() {
    return async function (dispatch: any, getState: any) {
        dispatch(setUserDetails(null));
        localStorage.setItem("user_logged_out", "true");
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        window.location.href = "/Login";
      };
  }